import { render, staticRenderFns } from "./FiltersIndex.vue?vue&type=template&id=31c32dd2"
import script from "./FiltersIndex.vue?vue&type=script&lang=js"
export * from "./FiltersIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports